<template>
  <v-dialog :value="value" max-width="800px" persistent :color="appButtonColor">
    <v-card>
      <v-card-title>
        <h2 class="headline pl-3">New Sponsor</h2>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md py-0 px-3>
          <v-layout wrap>
            <v-flex xs12 md6>
              <v-text-field
                :color="appButtonColor"
                hide-details
                v-model="newSponsor.username"
                label="Username"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field
                :color="appButtonColor"
                hide-details
                v-model="newSponsor.atts.email"
                type="text"
                label="Email"
                autocomplete="new-email"
              ></v-text-field>
              <!-- <span>{{ errors.first('email') }}</span>
              <span>{{ emailError }}</span>-->
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field
                :color="appButtonColor"
                hide-details
                v-model="newSponsor.atts['given_name']"
                label="First Name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field
                :color="appButtonColor"
                hide-details
                v-model="newSponsor.atts['family_name']"
                label="Last Name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6 v-if="!mersBranded">
              <v-text-field
                :color="appButtonColor"
                hide-details
                v-model="newSponsor.atts['custom:dateofbirth']"
                maxlength="8"
                label="Birthdate"
                name="birthdate"
                mask="##/##/####"
              ></v-text-field>
              <span>{{ errors.first('birthdate') }}</span>
            </v-flex>
            <v-flex xs12 md6>
              <v-layout>
                <v-flex xs4>
                  <v-select
                    :color="appButtonColor"
                    class="country-list"
                    hide-details
                    v-model="country"
                    :items="countries"
                    item-text="label"
                    item-value="value"
                  ></v-select>
                </v-flex>
                <v-flex>
                  <v-text-field
                    :color="appButtonColor"
                    hide-details
                    v-model="phone"
                    type="text"
                    name="phone"
                    placeholder="Phone"
                    :mask="phoneMask"
                  />
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field
                :color="appButtonColor"
                :rules="[rules.min, rules.upper, rules.number]"
                autocomplete="new-password"
                type="text"
                v-model="newSponsor.password"
                label="Password"
              ></v-text-field>
              <span :style="{color: infoColor}">{{ passwordInfo }}</span>
            </v-flex>
            <v-flex xs12 md6>
              <v-btn :class="mersBranded ? 'ma-0' : ''" @click="genPass">Generate Password</v-btn>
            </v-flex>
          </v-layout>
          <v-layout v-if="!mersBranded" wrap>
            <v-flex xs-2>
              <v-switch :color="appButtonColor" v-model="newSponsor.flags.isAdmin" label="isAdmin"></v-switch>
            </v-flex>
            <v-flex xs-2>
              <v-switch :color="appButtonColor" v-model="newSponsor.flags.isAlerus" label="isAlerus"></v-switch>
            </v-flex>
            <v-flex xs-2>
              <v-switch :color="appButtonColor" v-model="newSponsor.flags.isEnvestnet" label="isEnvestnet"></v-switch>
            </v-flex>
            <v-flex xs-2>
              <v-switch
                :color="appButtonColor"
                v-model="newSponsor.flags.isMERS"
                label="isMERS"
                :readonly="mersBranded ? true : false"
              ></v-switch>
            </v-flex>
            <v-flex xs-2>
              <v-switch :color="appButtonColor" v-model="newSponsor.flags.isFCMM" label="isFCMM"></v-switch>
            </v-flex>
          </v-layout>
          <v-layout v-if="!mersBranded" wrap>
            <v-flex xs-2>
              <v-switch :color="appButtonColor" v-model="newSponsor.flags.OCEAccess" label="OCEAccess"></v-switch>
            </v-flex>
            <v-flex xs-2>
              <v-switch :color="appButtonColor" v-model="newSponsor.flags.CFUAccess" label="CFUAccess"></v-switch>
            </v-flex>
            <v-flex xs-2>
              <v-switch :color="appButtonColor" v-model="newSponsor.flags.isICapital" label="isICapital"></v-switch>
            </v-flex>
            <v-flex xs-2>
              <v-switch :color="appButtonColor" v-model="newSponsor.flags.isKeating" label="isKeating"></v-switch>
            </v-flex>
            <v-flex xs-2>
              <v-switch :color="appButtonColor" v-model="newSponsor.flags.partAccess" label="partAccess"></v-switch>
            </v-flex>
            <v-flex shrink>
              <v-switch :color="appButtonColor" v-model="newSponsor.flags.planAccessAdmin" label="planAccessAdmin"></v-switch>
            </v-flex>
            <v-flex shrink mr-3>
              <v-switch :color="appButtonColor" v-model="newSponsor.flags.isWexFLXAdmin" label="isWexFLXAdmin"></v-switch>
            </v-flex>
            <v-flex shrink>
              <v-switch :color="appButtonColor" v-model="newSponsor.flags.isMersContact" label="isMersContact"></v-switch>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :color="appButtonColor" flat @click="setSponsor(false)">Cancel</v-btn>
        <v-btn :loading="saveLoading" :color="appButtonColor" flat @click="addSponsor">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import countries from "aws-amplify-vue/src/assets/countries";
export default {
  name: "sponsor",
  props: ["value"],
  data() {
    return {
      country: "1",
      countries,
      phone: "",
      saveLoading: false,
      sponsorCopy: {},
      infoColor: "green",
      passwordInfo: "",
      newSponsor: {
        username: "",
        password: "",
        atts: {
          given_name: "",
          family_name: "",
          email: "",
          email_verified: "true",
          phone_number: "",
          "custom:dateofbirth": ""
          // "custom:agreedterms": new Date().toISOString()
        },
        flags: {
          isAdmin: false,
          isAlerus: false,
          isFCMM: false,
          isICapital: false,
          isKeating: false,
          isMERS: false,
          isEnvestnet: false,
          OCEAccess: false,
          CFUAccess: false,
          partAccess: false,
          isWexFLXAdmin: false,
          isMersContact: false,
          planAccessAdmin: false
        }
      },
      rules: {
        birthdate: v => v.length === 0 || v.length <= 8 || "Error",
        required: v => !!v || "Required",
        min: v => v.length >= 8 || v.length === 0 || "Min 8 characters",
        upper: v =>
          /[A-Z]/.test(v) || v.length === 0 || "Must include uppercase letter",
        number: v => /[0-9]/.test(v) || v.length === 0 || "Must include number",
        email: v => /.+@.+/.test(v) || "Invalid email address"
      }
    };
  },
  created() {
    if (this.mersBranded) {
      this.newSponsor.flags.isMERS = true;
      this.newSponsor.flags.isAdmin = true;
    }
    this.sponsorCopy = JSON.parse(JSON.stringify(this.newSponsor));
  },
  computed: {
    ...mapState("user", ["mersBranded"]),
    appButtonColor() {
      return this.mersBranded ? "#33715A" : "#0B2A4A";
    },
    phoneMask() {
      if (this.country === "1") {
        return "(###) ###-####";
      } else return "##############";
    },
    newSponsorObject() {
      return {
        username: this.newSponsor.username.toLowerCase().trim(),
        password: this.newSponsor.password.trim(),
        newAtts: [...this.newSponsorAtts, this.newSponsorFlags]
      };
    },
    newSponsorFlags() {
      return {
        Name: "custom:userFlags",
        Value: JSON.stringify(this.newSponsor.flags)
      };
    },
    newSponsorAtts() {
      return Object.entries(this.newSponsor.atts).map(([key, value]) => {
        if (key === "given_name" || key === "family_name") {
          let newValue = value.toLowerCase().trim();
          return {
            Name: key,
            Value: `${newValue.charAt(0).toUpperCase()}${newValue.slice(1)}`
          };
        } else {
          return {
            Name: key,
            Value: value.trim()
          };
        }
      });
    }
  },
  methods: {
    ...mapMutations("accounts", ["setSponsor"]),
    async addSponsor() {
      if (!this.newSponsorObject.username || !this.newSponsorObject.password || (this.phone.length < 10 && this.country === "1")) return;
      this.saveLoading = true
      this.newSponsor.atts.email = this.newSponsor.atts.email.toLowerCase();
      this.newSponsor.atts['phone_number'] = `+${this.country}${this.phone}`
      this.newSponsor.atts['custom:countryCode'] = this.country
      let sponsor = await this.$store.dispatch(
        "accounts/newSponsor",
        this.newSponsorObject
      );
      if (sponsor) {
        this.setSponsor(false);
        this.newSponsor = this.sponsorCopy;
        this.phone = ""
      }
      this.saveLoading = false
    },
    genPass() {
      this.newSponsor.password = this.$generate({
        length: 12,
        numbers: true,
        symbols: true,
        strict: true,
        exclude: "\"`'"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>